import attributesActions from './attributes';
import sharedParameterActions from './sharedParameters';

export default {
  ...attributesActions,
  ...sharedParameterActions
};
